import { CompanyBase } from '../types/userProps'

export const getCompanyById = <T extends CompanyBase>(
  companies?: T[],
  id?: number
): T | undefined =>
  (id && companies?.find(({ companyId }: T) => companyId === id)) || undefined
